import { type ThemeState, themeStringToObject } from '@atlaskit/tokens';

import { updateThemeObjectWithDefaultValues } from './update-theme-object-with-default-values';
export const updateThemeWithDefaultValues = (themeString: string): Partial<ThemeState> =>
	updateThemeObjectWithDefaultValues(themeStringToObject(themeString));

export { updateThemeObjectWithDefaultValues } from './update-theme-object-with-default-values';
